import { useEffect, useState } from "react";

/**
 * @description This Hook handle the visibility of nudge animation
 *
 * @return {boolean} animation as isNudgeVisible
 */
const NUDGE_ANIMATION = "2520c75b-8c6f-4c53-8ac9-0bc5d5dfd816";

const useTimeoutEffect = (): boolean => {
  const [animation, setAnimation] = useState<boolean>(false);
  /**
   * @description This useEffect runs every reloads and make the nudge animation true for 1 sec if the flag is not set in session.
   * after 1 sec, it make the animation false.
   *
   * @returns void
   */
  useEffect(() => {
    const hasNudgeAnimation = sessionStorage?.getItem(NUDGE_ANIMATION);
    if (!hasNudgeAnimation) {
      setTimeout(() => {
        setAnimation(true);
      }, 500);
      const clearAnimationTimeout = setTimeout(() => {
        setAnimation(false);
        // setting a flag in session for preventing it runs again.
        sessionStorage?.setItem(NUDGE_ANIMATION, "true");
      }, 1500);
      return () => clearTimeout(clearAnimationTimeout);
    }
  }, []);

  return animation;
};

export default useTimeoutEffect;
